let $ = require('jquery');
import ModalView from "../comp/ModalView.js";
import i18n from "../../utils/i18n";
import POS from "../../POS.js";
let DbRecorder = require("../../recorder/DbRecorder.js");
import PrinterConverterUtil from "../../utils/PrinterConverterUtil.js";
import TableSelectModalView from "../comp/TableSelectModalView.js";
let {LogUtil} = require('../../utils/utils');
let Backbone = require("backbone");

let main = function () {
    return ModalView.extend({

        initialize: function () {
            if (this.tableSelectModalView == null) {
                this.tableSelectModalView = new TableSelectModalView({
                    collection: new Backbone.Collection(POS.getTables().filter(function (t) {
                        return !t.isWebTable();
                    }))
                });
            }
            this.listenTo(this.tableSelectModalView, "selectTable", this.onChangeTable);
        },

        render: function () {
            this.tableSelectModalView.model.set("collection", new Backbone.Collection(POS.getTables().filter(function (t) {
                return !t.isWebTable();
            })));
            this.tableSelectModalView.render(this.model);    // /pos/emptyTables
//                this.listenTo(this.tableSelectModalView.$el, 'hidden.bs.modal', function(){
//                    window.alert('hidden event fired!');
//                });
            var self = this;
            this.tableSelectModalView.$el.on('hidden.bs.modal', function () {
                self.trigger("closed");
            });
        },

        onChangeTable: function (table) {
            var targetTable = table.get("id");//this.$(".table-item.active").data("id");
            if (targetTable == null) {
                alert(i18n.template("pos.table.item.refund.error.nulltarget"));
            } else {
                var self = this;
                var deferred = this.model["switch"](targetTable, POS.getCurrentTable());
                var lastTable = POS.getCurrentTable();
                deferred.done(function () {
                    POS.setCurrentTable(table);

                    var newTable = POS.getCurrentTable();
                    var billDetail = DbRecorder.convert2JSON(newTable.get("currentBill"));
                    billDetail.targetTable = newTable.toJSON();
                    billDetail.lastTable = lastTable.toJSON();
                    if (typeof(chrome) !== 'undefined' && typeof(chrome.runtime) !== 'undefined') {
                        chrome.runtime.sendMessage(DbRecorder.read("chromeAppId"), {msg: PrinterConverterUtil.toSwitchTableReceipt(billDetail)});
                    }
                    // analytics('send', 'event', 'switchTable', 'printReceipt', POS.getRestaurant().get('name'));
                    LogUtil.info('TableView', 'printReceipt');

                    self.$el.modal("hide");
                    Backbone.history.navigate("overview", {trigger: true});
                    new ModalView({body: "<h1 class='large' style='text-align: center;'>" + i18n.msg("pos.table.switch.success", table.get("name")) + "</h1>"}).render().$(".modal-footer").hide();
                });
                deferred.fail(function (response) {
                    new ModalView({body: "<h1 class='large' style='color: red; text-align: center;'>" + response.message + "</h1>"}).render().$(".modal-footer").hide();
                });
            }
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/table/SwitchTableModalView.js